<template>
	<div>
		<el-upload ref="upload" :action="uploadPath" list-type="picture-card" :fileList="filelist" :limit="limit" :data='data'
			:on-success="success" :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
			<i class="el-icon-plus"></i>
		</el-upload>
		<el-dialog :visible.sync="dialogVisible" append-to-body>
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			limit: {
				type: Number,
				default: 1
			},
      data: {
      	type: Object,
      	default: {}
      }
		},
		data() {
			return {
				dialogImageUrl: '',
				dialogVisible: false,
				uploadPath: this.$api.BaseUrl + this.$api.uploadImage,
				imagePath: this.$api.imagePath,
				filelist: [],
			}
		},
		mounted() {

		},
		methods: {
			success(data, file, filelist) {
				let index = filelist.indexOf(file);
				this.filelist.push({
					name: data.msg,
					index: index,
					url: this.imagePath + data.data.path,
          sub_url:data.data.path
				})

        if(this.limit == 1){
          let url = data.data.path;
          this.$emit("change", url);
        }else{
          let urls = [];
          this.filelist.forEach((item,index)=>{
            urls.push(item.sub_url)
          })
          this.$emit("change", urls);
        }

			},
			handleRemove(file, fileList) {
				let index = file.index;
				this.filelist.splice(index, 1);
        let urls = [];
        if(this.limit==1){
          this.$emit("change","");
        }else{
          this.filelist.forEach((item,index)=>{
            urls.push(item.sub_url)
          })
          this.$emit("change",urls);
        }
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
      clearFiles(){
        this.filelist = []
        this.$refs.upload.clearFiles()
      },
			setFiles(data) {
        this.filelist=[]
				if (typeof data == 'object') {
					data.forEach((item, index) => {
						this.filelist.push({
							name: item,
							index: index,
							url: this.imagePath + item,
              sub_url:item
						})
					});
				}
			},
		}
	}
</script>

<style>
	.el-upload-list__item {
	  transition: none !important;
	}
	 .el-upload-list__item-thumbnail {
	    /* 圖片在方框内显示长边 */
	    object-fit: scale-down !important;
	}

	::v-deep .el-upload-list__item {
	  transition: none !important;
	}
	::v-deep .el-upload-list__item-thumbnail {
	    /* 圖片在方框内显示长边 */
	    object-fit: scale-down !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/upload/Upload.vue